import { Button, Modal } from "antd";
import "./PublishRecentChangesModal.scss";

export interface PublishRecentChangesModalProps {
  visible: boolean;
  onSkip: () => void;
  onPublish: () => void;
  onClose: () => void;
}

export default function PublishRecentChangesModal({ visible, onSkip, onPublish, onClose }: PublishRecentChangesModalProps) {
  return (
    <Modal className="clean publish-recent-changes" visible={visible} onCancel={onClose} width={600} footer={null}>
      <div className="prc-body">
        <div className="prc-text">
          <h3>Publish recent changes?</h3>
          <p>Some menus have unpublished changes.</p>
        </div>
        <div className="prc-actions">
          <Button className="prc-skip" size="large" onClick={onSkip}>Skip</Button>
          <Button size="large" type="primary" onClick={onPublish}>Publish changes</Button>
        </div>
      </div>
    </Modal>
  );
}
